export const securityWaitingMessage = (id, firstName = null) => {
  switch (id) {
    case 0:
      return `Thank You, ${firstName}! It could take up to 60 seconds to verify.`;
    case 1:
      return 'Thank you for your patience, your security is important to us.';
    case 2:
      return 'With over 4,000 5-star reviews, you\'re in good hands.';
    case 3:
      return '"LendingUSA was awesome to work with"';
    case 4:
      return '"The most pleasant experience I\'ve ever had applying for a loan"';
    case 5:
      return '"Very easy, very professional. Thanks for a pleasant experience!"';
    case 6:
      return `We're nearly finished. Thank you for your patience, ${firstName}.`;
    default:
      return null;
  }
};
